// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  
  production: false,

  betaShowOverride: false,  // Show the beta override checkbox in the UI.
  betaDefaultValue: true,  // Default value for enabling/disabling beta features.
  
  urlCorrespondenceManager: 'http://localhost:4200/correspondence',
  urlDiaryManager: 'http://localhost:4200/diarymanager?showMenu=false&useMember=true',
  urlEligibilityViewer: 'http://localhost:4200/eligibility',

  devUserId:9,  // -9=Zach, 13=Tom
  version:"1.70",

  azureAdClientId: '217fef7b-f452-4620-bd67-5d160f93f153',
  azureAdAuthority: 'https://login.microsoftonline.com/0c7cab0e-8f19-4bde-a901-4b7b35f056e3',
  // azureAdRedirectUri: 'https://reinhardt.tandemcare.com:4431',
  // tcemsAPIBase: 'https://reinhardt.tandemcare.com:8081',
  // logoutRedirect: 'https://reinhardt.tandemcare.com:4431',
  azureAdRedirectUri: 'http://localhost:4201',
  tcemsAPIBase: 'https://localhost:8081',
  logoutRedirect: 'http://localhost:4201',

  tcemsAPI_phi: '/api/phi',
  tcemsAPI_edi: '/api/edi',
  tcemsAPI_util: '/api/util',
  tcemsAPI_claims: '/api/claims',
  tcemsAPI_encounter: '/api/encounter',
  tcemsAPI_finance: '/api/finance',
  tcemsAPI_support: '/api/support',
  tcemsAPI_reports: '/api/reporting',
  tcemsAPI_provider: '/api/provider',
  tcemsAPI_geocode: '/api/geocode',
  tcemsAPI_comm: '/api/comm',
  tcemsAPI_job: '/api/jobs',
  tcemsAPI_publicapi: '/api/publicapi',
  harlowe: 
  {
    hubs:
    {
      presence: 
      {
        endpoint: '/hubs/presence',
      }
    }
  },
  azureAPIBase: 'https://graph.microsoft.com',
  azureAPI_me: '/v1.0/me',
  azureAPIScope_me: 'User.Read',
  thAPIBase: 'http://localhost:8080/tealhealth/api',
  azureAdConsentScopes: 
  [
    '217fef7b-f452-4620-bd67-5d160f93f153/.default'
  ],
  azureAdProtectedResourceMap: 
  [
    ['https://localhost:8081',['217fef7b-f452-4620-bd67-5d160f93f153/.default']],
    ['https://graph.microsoft.com/v1.0/me',['user.read']],
    ['http://localhost:8080',['api://d2bb3f54-0138-47dd-b6d8-6be52e1a08c5/Login']]
  ] as [string, string[]][], //If we don't give the explicit cast, then the module.ts import statement bitches at us...
  chatURI:'https://chat.harlowehealth.com',
  defaultEmailDomain:"harlowehealth.com",

};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
